/**
 * Sakstidslinje - visuell fremdriftsindikator for saker
 *
 * Viser hvor langt man har kommet i saksgangen
 */

import React, { useState } from 'react';
import './SaksTimeline.css';

// Standard faser i en advokatoppfølging
const DEFAULT_FASER = [
  { id: 1, navn: 'Innsalg', ikon: '🤝', beskrivelse: 'Første kontakt og inngåelse av oppdragsavtale' },
  { id: 2, navn: 'Oppdrag', ikon: '📝', beskrivelse: 'Oppdragsbekreftelse sendt og akseptert' },
  { id: 3, navn: 'Datainnsamling', ikon: '📂', beskrivelse: 'Innhenting av dokumenter og beviser' },
  { id: 4, navn: 'Juridisk vurdering', ikon: '⚖️', beskrivelse: 'Analyse av saken og vurdering av rettsstilling' },
  { id: 5, navn: 'Reklamasjon', ikon: '📮', beskrivelse: 'Sending av reklamasjon til motpart' },
  { id: 6, navn: 'Spesifisert krav', ikon: '📊', beskrivelse: 'Utarbeidelse av detaljert krav' },
  { id: 7, navn: 'Søksmålsvarsel', ikon: '⚠️', beskrivelse: 'Varsel om stevning hvis forlik ikke oppnås' },
  { id: 8, navn: 'Stevning/Anke/Forliksklage', ikon: '📜', beskrivelse: 'Innlevering av stevning, anke eller forliksklage' },
  { id: 9, navn: 'Planmøte', ikon: '👥', beskrivelse: 'Planleggingsmøte i retten' },
  { id: 10, navn: 'Avsluttet saksforberedelse', ikon: '✅', beskrivelse: 'Ferdigstillelse av alle dokumenter' },
  { id: 11, navn: 'Sluttinnlegg', ikon: '📄', beskrivelse: 'Skriftlig sluttinnlegg innlevert' },
  { id: 12, navn: 'Innledningsforedrag', ikon: '🎤', beskrivelse: 'Muntlig fremstilling i retten' },
  { id: 13, navn: 'Prosedyre', ikon: '⚡', beskrivelse: 'Gjennomføring av hovedforhandling' },
  { id: 14, navn: 'Sakskostnadsoppgave', ikon: '💰', beskrivelse: 'Oppstilling av kostnader til hovedforhandling' },
  { id: 15, navn: 'Dom', ikon: '⚖️', beskrivelse: 'Tingrettens eller lagmannsrettens dom avsagt' }
];

const SaksTimeline = ({ sakId, currentPhaseId = 1, completedPhases = [], onPhaseUpdate }) => {
  const [hoveredPhase, setHoveredPhase] = useState(null);

  const handlePhaseClick = (phase) => {
    if (onPhaseUpdate) {
      onPhaseUpdate(phase.id);
    }
  };

  return (
    <div className="saks-timeline">
      <h3 className="timeline-header">📍 Sakens fremdrift</h3>

      <div className="timeline-stats">
        <div className="stat">
          <strong>{completedPhases.length}</strong>
          <span>fullført</span>
        </div>
        <div className="stat">
          <strong>{currentPhaseId}</strong>
          <span>nåværende</span>
        </div>
        <div className="stat">
          <strong>{DEFAULT_FASER.length - completedPhases.length}</strong>
          <span>gjenstår</span>
        </div>
      </div>

      <div className="timeline-track">
        {DEFAULT_FASER.map((fase, index) => {
          const isCompleted = completedPhases.includes(fase.id);
          const isCurrent = fase.id === currentPhaseId;
          const isPending = fase.id > currentPhaseId;

          return (
            <div
              key={fase.id}
              className={`timeline-phase ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''} ${isPending ? 'pending' : ''}`}
              onClick={() => handlePhaseClick(fase)}
              onMouseEnter={() => setHoveredPhase(fase)}
              onMouseLeave={() => setHoveredPhase(null)}
            >
              <div className="phase-connector" />
              <div className="phase-marker">
                <span className="phase-icon">{fase.ikon}</span>
                {isCompleted && <span className="check-mark">✓</span>}
                {isCurrent && <span className="current-pulse" />}
              </div>
              <div className="phase-label">
                <strong>{fase.navn}</strong>
                <span className="phase-number">#{fase.id}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Tooltip ved hover */}
      {hoveredPhase && (
        <div className="timeline-tooltip">
          <div className="tooltip-header">
            <span className="tooltip-icon">{hoveredPhase.ikon}</span>
            <strong>{hoveredPhase.navn}</strong>
          </div>
          <p>{hoveredPhase.beskrivelse}</p>
        </div>
      )}
    </div>
  );
};

export default SaksTimeline;
